import { AgentComponentType } from '@reach/shared-types/agent-components';
import { agentBuilderNestedRoutes, appRoutes } from '../../app-routes';

const LIST_PATHS: Record<AgentComponentType, string> = {
  [AgentComponentType.SKILL]: appRoutes.AGENT_SKILLS,
  [AgentComponentType.GUIDANCE]: appRoutes.AGENT_GUIDANCE,
  [AgentComponentType.ESCALATION]: appRoutes.AGENT_ESCALATIONS,
};

/** The list page for a component type. */
export const componentListPath = (type: AgentComponentType): string => LIST_PATHS[type];

/** The page that creates a component of a type. */
export const newComponentPath = (type: AgentComponentType): string =>
  `${LIST_PATHS[type]}/${agentBuilderNestedRoutes.NEW_COMPONENT}`;

/** The page for one saved component. */
export const componentPath = (type: AgentComponentType, componentId: string): string =>
  `${LIST_PATHS[type]}/${componentId}`;
